import ContentfulInformationPage from 'models/data/contentful/ContentfulInformationPage'

class ContentfulToApiInformationPage {
	static map = contentfulInformationPage => ({
		title: ContentfulInformationPage.title(contentfulInformationPage),
		bodyHtml: ContentfulInformationPage.bodyHtml(contentfulInformationPage)
	});
}

export default ContentfulToApiInformationPage;